import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await login(email, password);
      toast.success('¡Bienvenido de vuelta!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <div className="max-w-md w-full glass-effect p-8 rounded-xl">
        <div className="mb-8 text-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_virtualgolf-2/artifacts/si8l522g_IMG_1926.png" 
            alt="City Virtual Golf" 
            className="h-16 w-auto mx-auto mb-4"
          />
          <h1 className="text-3xl font-heading font-bold uppercase tracking-tight" data-testid="login-title">Iniciar Sesión</h1>
          <p className="text-muted-foreground mt-2" data-testid="login-subtitle">Accede a tu cuenta</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 bg-white/5 border-white/10"
              data-testid="login-email-input"
            />
          </div>

          <div>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 bg-white/5 border-white/10"
              data-testid="login-password-input"
            />
          </div>

          <Button 
            type="submit" 
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider py-6"
            disabled={loading}
            data-testid="login-submit-button"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </Button>
        </form>

        <div className="mt-4 text-center">
          <Link 
            to="/forgot-password" 
            className="text-sm text-accent hover:underline"
            data-testid="forgot-password-link"
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <p className="mt-6 text-center text-muted-foreground" data-testid="login-register-link">
          ¿No tenés cuenta?{' '}
          <Link to="/register" className="text-accent hover:underline">
            Registrate acá
          </Link>
        </p>
      </div>
    </div>
  );
};